<template>
  <div :class="{ box: true }">
  <div class="main-box">
    <div :class="{ text:true }">
      <div class="switch-bottom-box" @click="onChangeBottomBar">
        <font-awesome-icon icon="caret-up" class="icon" v-if="bottomBarState"/>
        <font-awesome-icon icon="caret-down" class="icon" v-if="!bottomBarState"/>
      </div>
      <div class="play-box">
        <div @click="playButton" :class="{ play: true, playing }" title="Play/Stop">
          <font-awesome-icon icon="volume-up" class="icon"/>
        </div>
      </div>
      <textarea :class='{ autoExpand: true, "textareaText": true }' @keydown.enter="prevent" @change="saveText('text')" placeholder="Add answer ..." maxlength="350" spellcheck="false" v-model="text"></textarea>
      <textarea :class='{ autoExpand: true, "textareaHint": true }' @keydown.enter="prevent" @change="saveText('hint')" :placeholder="getAutoHint" maxlength="350" spellcheck="false" title="prompt" v-model="hint"></textarea>
    </div>
    <div class="bottom-bar" v-if="bottomBarState">
    <div class="option-bar">
      <div class="left-options">

        <div class="bot" @click="botSwitchChange" :class="{ active: this.switch == 'bot' }" title="Automatic voice">
          <font-awesome-icon icon="robot"/>
        </div>

        <div class="micro" @click="microSwitchChange" :class="{ active: this.switch == 'micro' }" title="Record voice">
          <font-awesome-icon icon="microphone"/>
        </div>

        <div class="feedback" @click="switchFeedback" :class="{ active: this.feedback }" title="Feedback">
          <font-awesome-icon icon="check"/>
        </div>

        <div class="recordDisable" @click="switchRecordDisable" :class="{ active: this.recordDisable }" title="Disable student recording">
          <font-awesome-icon icon="comment-slash"/>
        </div>

      </div>
      <div class="right-options">
        <div class="trash" @click="onDelete" title="Delete">
          <font-awesome-icon icon="trash"/>
        </div>
      </div>
    </div>

    <div class="tts-bar" v-if="this.switch=='bot' && !this.feedbackBar">
      <select name="tts-voice" v-model="selectedVoice" @change="onVoiceChange" title="Language">
        <option v-for="(voice, index) in voices" :key="index" :value="{ name: voice.name, lang: voice.lang }">
          {{ voice.name }}
        </option>
      </select>
    </div>

    <div class="record-bar" v-if="this.switch=='micro' && !this.feedbackBar">
      <div class="record-box" v-if="this.switch=='micro'">
        <div :class="{ record: true, recording }" @click="recordButton" title="Record/Stop">
          <font-awesome-icon v-if="!recording" icon="circle"/>
          <font-awesome-icon v-if="recording" icon="stop"/>
        </div>
        <div class="timer" >
          {{ time }} / 00:60
        </div>
      </div>
    </div>

    <div class="feedback-bar" v-if="this.feedbackBar">
      <div class="feedback-status">
        <div :class="{'info': true, 'info-active': this.feedbackStatus == 'info'}" title="Info" @click="switchFeedbackStatus('info')">
          <font-awesome-icon icon="info"/>
        </div>

        <div :class="{'success': true, 'success-active': this.feedbackStatus == 'success'}" title="Success" @click="switchFeedbackStatus('success')">
          <font-awesome-icon icon="check"/>
        </div>

        <div :class="{'error': true, 'error-active': this.feedbackStatus == 'error'}" title="Error" @click="switchFeedbackStatus('error')">
          <font-awesome-icon icon="times"/>
        </div>
      </div>
      <div class="feedback-message">
        <input type="text" placeholder="Feedback Message" v-model="feedbackMessage" @change="onFeedbackMessageChange">
      </div>
    </div>

    </div>
  </div>
  <div class="next-box">
    <div class="not-selected" v-if="!selected">
      <div class="add-box">
        <div class="add-button" @click="addNextQuestion" title="Add Next Question">
          <div class="button">
            <font-awesome-icon icon="plus"/>
          </div>
          <div class="label">
            <span class="normal">Add Question</span>
            <span class="long">Add Next Question</span>
            <span class="short">Question</span>
          </div>
        </div>
      </div>
      <div class="or-box" v-if="allBotsWithoutCurrent.length > 0">or</div>
      <div class="select-box" v-if="allBotsWithoutCurrent.length > 0">
        <select name="next" v-model="selected" @change="onSelectChange" title="Select Next Question">
          <option value="null" disabled>Select Next</option>
          <option v-for="bot in allBotsWithoutCurrent" :key="bot.id" :value="bot.id">
            <span v-if="bot.text.length < 25">{{bot.text}}</span>
            <span v-if="bot.text.length >= 25">{{bot.text.split('').splice(0, 20).join('') + ' ...'}}</span>
          </option>
        </select>
      </div>
    </div>
    <div class="selected" v-if="selected">
      <div class="next-button" @click="goNextQuestion" title="Go Next">
        <div class="arrow-box">
          <font-awesome-icon icon="arrow-right"/>
        </div>
        <div class="text-box">{{getSelectedText}}</div>
      </div>
      <div class="delete-button">
        <font-awesome-icon icon="times-circle" class="icon" @click="deleteNext"/>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import alert from '@/lib/alert'
import autosize from 'autosize'
import { mapActions, mapGetters } from 'vuex';
import loadVoices from '@/lib/ttsVoices'

export default {
  name: 'answer',
  props: {
    saved: Object,
    index: Number
  },
  data() {
    return {
      id: this.saved.id,
      text: this.saved.text,
      hint: this.saved.hint,
      hintSwitch: false,
      data: this.saved.audioData,
      selected: this.saved.next,
      switch: this.saved.audioType,
      playing: false,
      recording: false,
      recordingTime: this.saved.recordingTime,
      timerTimeOut: null,
      voices: [],
      selectedVoice: this.saved.selectedVoice,
      recordDisable: this.saved.recordDisable,
      feedback: this.saved.feedback || false,
      feedbackStatus: this.saved.feedbackStatus || 'info',
      feedbackMessage: this.saved.feedbackMessage || null,
      feedbackBar: false
    }
  },
  methods: {
    ...mapActions('edit', ['deleteAnswer', 'answerSaveText', 'addNextBot', 'addExistingToAnswer', 'goToNextBot', 'answerChangeSwitch', 'answerSaveTime', 'answerChangeAudioData', 'answerChangeVoice', 'answerChangeBottomBar', 'changeRecordDisable', 'changeFeedback', 'changeFeedbackStatus', 'changeFeedbackMessage']),
    ...mapActions('player', ['playerPlay', 'playerStop', 'playerRecordingStart', 'playerRecordingStop']),
    prevent(event) {
      event.preventDefault();
    },
    onVoiceChange() {
      this.answerChangeVoice({ voice: this.selectedVoice, id: this.id});
    },
    onDelete() {
      this.deleteAnswer(this.id);
    },
    saveText(type) {
      if(type == 'text') {
        this.answerSaveText({ text: this.text, id: this.id, type: 'text' });
      } else {
        this.answerSaveText({ text: this.hint, id: this.id, type: 'hint' });
      }
    },
    goNextQuestion() {
      this.goToNextBot(this.saved.next);
    },
    deleteNext() {
      this.selected = null;
      this.onSelectChange();
    },
    addNextQuestion() {
      this.addNextBot(this.id);
    },
    onSelectChange() {
      this.addExistingToAnswer({ answerId: this.id, nextId: this.selected });
    },
    onNext() {
      if(this.saved.next) {
        this.goToNextBot(this.saved.next);
      }
    },
    botSwitchChange() {
      if(this.switch == 'bot') {
        if(this.feedbackBar) {
          this.feedbackBar = false;
        } else {
          this.switchChange(null);
        }
      } else {
        this.switchChange('bot');
        this.feedbackBar = false;
      }
    },
    microSwitchChange() {
      if(this.switch == 'micro') {
        if(this.feedbackBar) {
          this.feedbackBar = false;
        } else {
          this.switchChange(null);
        }
      } else {
        this.switchChange('micro');
        this.feedbackBar = false;
      }
    },
    switchRecordDisable() {
      this.recordDisable = !this.recordDisable;
      this.changeRecordDisable({ disableState: this.recordDisable, id: this.id });
    },
    switchFeedback() {
      if(this.feedback) {
        if(this.feedbackBar) {
          this.feedback = false;
          this.feedbackBar = false;
          this.changeFeedback({ feedback: false, id: this.id });
        } else {
          this.feedbackBar = true;
        }
      } else {
        this.feedback = true;
        this.feedbackBar = true;
        this.changeFeedback({ feedback: true, id: this.id });
      }
    },
    switchFeedbackStatus(to) {
      this.feedbackStatus = to;
      this.changeFeedbackStatus({ feedbackStatus: to, id: this.id });
    },
    onFeedbackMessageChange() {
      this.changeFeedbackMessage({ feedbackMessage: this.feedbackMessage, id: this.id });
    },
    switchChange(to) {
      if(this.playing) {
        this.stop();
      }
      if(this.recording) {
        this.stopRecord();
      }
      this.switch = to;
      this.answerChangeSwitch({ switchState: this.switch, id: this.id});
    },
    hintChange() {
      this.stop();
      this.hintSwitch = !this.hintSwitch;
    },
    playButton() {
      if(!this.recording) {
        if(this.playing) {
          this.stop();
        } else {
          if(this.playingState) {
            this.playerStop();
            this.play();
          } else {
            this.play();
          }
        }
      } else {
        console.log(`Error: Recording`);
        alert.showError('Recording');
      }
    },
    play() {
      if(this.switch == 'bot') {
        let text = '';
        if(this.hintSwitch) {
          text = this.hint;
          if(text.trim() == '') {
            console.log(`Error: No hint to read`);
            alert.showError('No hint to read');
          } else {
            this.playing = true;
            this.playerPlay({ type: 'bot', payload: { text, voice: this.selectedVoice } }).then(() => {
              this.playing = false;
            }).catch(err => {
              this.playing = false;
              console.log(`Error: ${err}`);
              alert.showError(err);
            });
          }
        } else {
          text = this.text;
          if(text.trim() == '') {
            console.log(`Error: No text to read`);
            alert.showError('No text to read');
          } else {
            this.playing = true;
            this.playerPlay({ type: 'bot', payload: { text, voice: this.selectedVoice } }).then(() => {
              this.playing = false;
            }).catch(err => {
              this.playing = false;
              console.log(`Error: ${err}`);
              alert.showError(err);
            });
          }
        }
      } else if(this.switch == 'micro'){
        this.playing = true;
        this.playerPlay({ type: 'micro', payload: this.data }).then(() => {
          this.playing = false;
        }).catch(err => {
          this.playing = false;
          console.log(`Error: ${err}`);
          alert.showError(err);
        });
      }
    },
    stop() {
      this.playerStop();
      this.playing = false;
    },
    recordButton() {
      if(!this.playing) {

        if(this.recording) {
          this.stopRecord();
        } else {
          if(this.recordingState) {
            console.log(`Error: Currently recording`);
            alert.showError('Currently recording');
          } else {
            this.record();
          }
        }

      } else {
        console.log(`Error: Playing`);
        alert.showError('Playing');
      }
    },
    record() {
      this.playerRecordingStart().then(() => {
        this.recordingTime = 0;
        this.timer();
        this.recording = true;
      }).catch(err => {
        console.log(`Error: ${err}`);
      })
    },
    stopRecord() {
      this.recording = false;
      clearTimeout(this.timerTimeOut);
      this.answerSaveTime({time: this.recordingTime, id: this.id});
      this.playerRecordingStop().then(data => {
        this.data = data.data;
        this.answerChangeAudioData({ audioData: this.data, id: this.id});
      }).catch(err => {
        console.log(`Error: ${err}`);
        alert.showError(err);
      })
    },
    timer() {
      this.recordingTime += 1;
      if(this.recordingTime == 60) {
        this.stopRecord();
      } else {
        this.timerTimeOut = setTimeout(this.timer, 1000);
      }
    },
    onChangeBottomBar() {
      this.answerChangeBottomBar(this.index);
    }
  },
  mounted() {
    autosize(document.querySelectorAll('textarea'));
    loadVoices().then(voices => {
      this.voices = voices;
      let findVoice = voices.find(voice => {
        return voice.name == this.selectedVoice.name;
      });
      if(!findVoice) {
        let findByLang = voices.find(voice => {
          return voice.lang.slice(0,2) == this.selectedVoice.lang.slice(0,2) && voice.lang.slice(3,5) == this.selectedVoice.lang.slice(3,5);
        });
        if(findByLang) {
          this.selectedVoice = { name: findByLang.name, lang: findByLang.lang };
          this.answerChangeVoice({ voice: { name: findByLang.name, lang: findByLang.lang }, id: this.id});
        } else {
          let findAvailable = voices.find(voice => {
            return voice.lang.slice(0,2) == this.selectedVoice.lang.slice(0,2);
          });
          if(findAvailable) {
            this.selectedVoice = { name: findAvailable.name, lang: findAvailable.lang };
            this.answerChangeVoice({ voice: { name: findAvailable.name, lang: findAvailable.lang }, id: this.id});
          }
        }
      }
    });
    if(this.recordDisable == undefined) {
      this.changeRecordDisable({ disableState: false, id: this.id });
    }
  },
  computed: {
    ...mapGetters('player', ['playingState', 'recordingState']),
    ...mapGetters('edit', ['allBotsWithoutCurrent', 'getBottomBarState']),
    time() {
      if(this.recordingTime < 10) {
        return '00:0' + this.recordingTime;
      } else {
        return '00:' + this.recordingTime;
      }
    },
    getSelectedText() {
      let bot = this.allBotsWithoutCurrent.find(bot => {
        return bot.id == this.selected;
      })
      return bot.text;
    },
    getAutoHint() {
      if(this.text == '') {
        return 'Add hint ...';
      } else {
        let array = this.text.split(' ');
        if(array[0] && array[1]) {
          return `${array[0]} ${array[1]}...`;
        } else {
          return `${array[0]}...`;
        }
      }
    },
    bottomBarState() {
      switch(this.index) {
        case 0 : return this.getBottomBarState.answer_0;
        case 1 : return this.getBottomBarState.answer_1;
        case 2 : return this.getBottomBarState.answer_2;
        case 3 : return this.getBottomBarState.answer_3;
        default: return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 29rem;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  @media (max-width: 1000px) {
    width: 100%;
  }

  .main-box {
    width: 100%;
    height: auto;
    background-color: rgb(37, 38, 41);
    border-radius: 0.5rem;
    filter:drop-shadow(8px 8px 20px rgba(0, 0, 0, 0.349));
  }

  .next-box {
    width: 100%;
    height: 4rem;
    margin-top: 0.8rem;
    // background-color: rgb(37, 38, 41);
    background-color: #11b6a5;
    filter:drop-shadow(8px 8px 20px rgba(0, 0, 0, 0.199));
    border-radius: 0.5rem;
    display: flex;

    .selected {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .not-selected {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .next-button {
      width: 23rem;
      height: 2.5rem;
      margin-left: 1rem;
      background-color: #11b6a5;
      border-radius: 0.3rem;
      display: flex;
      align-items: center;
      transition: 0.2s;
      overflow: hidden;

      @media (max-width: 1000px) {
        width: 60vw;
      }
      @media (max-width: 600px) {
        width: 75vw;
      }
      @media (max-width: 450px) {
        width: 70vw;
      }
      @media (max-width: 350px) {
        width: 65vw;
      }

      &:hover {
        cursor: pointer;
        filter: brightness(0.9);
      }

      .arrow-box {
        width: 2.5rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.1rem;
        color: white;    
      }

      .text-box {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 1.1rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        color: white;

        &::after {
          content: '';
          position: absolute;
          width: 2.5rem;
          height: 2.5rem;
          background-image: linear-gradient(to right, #11b6a680 , #11b6a5);
          bottom: 0;
          right: 0;
        }
      }
    }

    .delete-button {
      width: 2.5rem;
      height: 2.5rem;
      margin-right: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.8rem;

      .icon {
        color: white;
        transition: 0.2s;
          &:hover {
          cursor: pointer;
          filter: brightness(0.9);
        }
      }
    }

    .add-box {
      flex: 2;
      height: 100%;
      display: flex;
      align-items: center;

      @media (max-width: 400px) {
        flex: 1.5;
      }
      @media (max-width: 360px) {
        flex: 0.6;
      }

      .add-button {
        width: auto;
        height: 2.5rem;
        margin-left: 1rem;
        display: flex;
        align-items: center;
        transition: 0.2s;

        &:hover {
          cursor: pointer;
          filter: brightness(0.9);
        }
      }

      .button {
        width: 2rem;
        height: 2rem;
        background-color: white;
        border-radius: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .label {
        color: white;
        margin-left: 0.7rem;
        font-size: 1.1rem;

        .normal {
          display: unset;
          @media (max-width: 1000px) {
            display: none;
          }
          @media (max-width: 630px) {
            display: unset;
          }
          @media (max-width: 400px) {
            display: none;
          }
        }

        .long {
          display: none;
          @media (max-width: 1000px) {
            display: unset;
          }
          @media (max-width: 630px) {
            display: none;
          }
        }

        .short {
          display: none;
          @media (max-width: 400px) {
            display: unset;
          }
          @media (max-width: 360px) {
            display: none;
          }
        }
      }

    }

    .or-box {
      flex: 0.5;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 1.2rem;

      @media (max-width: 630px) {
        display: none;
      }
    }

    .select-box {
      flex: 2;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      select {
        margin-right: 1rem;
        width: 85%;
        height: 2.5rem;
        font-size: 1rem;
        padding-left: 0.3rem;
        outline: none;
        border: none;
        border-radius: 0.3rem;
        cursor: pointer;

        @media (max-width: 630px) {
          width: 100%;
        }
      }
    }
  }

  .text {
    width: 100%;
    height: auto;
    background-color: #e6c17d;
    border-radius: 0.5rem;
    position: relative;
    padding-bottom: 1rem;
    padding-top: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: 1000px) {
      width: 100%;
    }

    .switch-bottom-box {
      position: absolute;
      left: 0.5rem;
      bottom: 0.5rem;
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 0.3rem;
      background-color: rgb(37, 38, 41);
      color: white;
      cursor: pointer;
      font-size: 1.1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .play-box {
      width: auto;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 0.5rem;
      bottom: 0.5rem;
      @media (max-width: 1000px) {
        height: 3rem;
      }

      .playing {
        background-color: #292f36 !important;
        color: white !important;
      }

      .play {
        width: 2.2rem;
        height: 2.2rem;
        border-radius: 50%;
        background-color: white;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: 0.3s;
        font-size: 0.9rem;
        @media (max-width: 1000px) {
          width: 2rem;
          height: 2rem;
          font-size: 1rem;
        }
      }
    }

    .textareaText {
      width: 100%;
      height: 100%;
      min-height: 4rem;
      background: none;
      border: none;
      text-align: center;
      font-size: 1.2rem;
      padding: 1rem;
      resize: none;
      outline: none;
      overflow: hidden;
      display: block;
      box-sizing: padding-box;
      &::placeholder {
        color: rgba(0, 0, 0, 0.616);
      }

      @media (max-width: 1000px) {
        font-size: 1rem;
      }
    }

    .textareaHint {
      width: 70%;
      height: 1.5rem;
      min-height: 1.5rem;
      background: none;
      border: none;
      text-align: center;
      font-size: 1.2rem;
      padding-left: 1rem;
      padding-right: 1rem;
      resize: none;
      outline: none;
      overflow: hidden;
      display: block;
      box-sizing: padding-box;
      color: rgba(0, 0, 0, 0.616);
      &::placeholder {
        color: rgba(0, 0, 0, 0.616);
      }

      @media (max-width: 1000px) {
        font-size: 1rem;
      }
    }
  }

  .option-bar {
    width: 100%;
    height: 3rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    @media (max-width: 1000px) {
      width: 100%;
    }

    .left-options {
      flex: auto;
      max-width: 12rem;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;

      .bot {
        width: 2rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .micro {
        width: 2rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .recordDisable {
        width: 2rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .feedback {
        width: 2rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;
        margin-left: 1rem;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .active {
        background-color: rgb(131, 83, 194);
        color: white;
      }

      .switch {
        width: 2rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }
        @media (max-width: 500px) {
          width: 1.7rem;
          height: 1.7rem;
          font-size: 0.9rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .activeHint {
        background-color: darkcyan;
        color: #fcc84f;
      }
    }

    .select-box {
      width: 15rem;
      height: 100%;
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 1000px) {
        flex: auto;
      }
      @media (max-width: 500px) {
        width: 11rem;
      }

      .button-box {
        width: 90%;
        height: 70%;
        background-color: white;
        display: flex;
        flex-direction: row;
        position: relative;
        border-radius: 0.2rem;
        overflow: hidden;

        .button {
          position: absolute;
          width: calc(100% - 2.3rem);
          height: 100%;
          z-index: 2;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #11b6a5;
          transition: 0.3s;
          color: white;
          border-right: 2px solid rgba(255, 255, 255, 0.692);

          &:hover {
            cursor: pointer;
            background-color: #0f978a;
          }
        }

        .drop-box {
          position: absolute;
          width: 2.3rem;
          right: 0;
          height: 100%;
          z-index: 1;
          background-color: #11b6a5;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            color: white;
          }

          &:hover {
            background-color: #10998b;
          }
        }

        select {
          position: absolute;
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background: none;
          z-index: 1;
          font-size: 0.9rem;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          cursor: pointer;
          padding-left: 0.3rem;

          .empty {
            background-color: rgb(224, 116, 106);
            color: white;
            font-weight: bold;
          }
        }
      }
    }

    .right-options {
      flex: auto;
      max-width: 4rem;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      margin-left: auto;

      .next {
        width: 2rem;
        height: 2rem;
        background-color: darkcyan;
        border-radius: 0.5rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }
        @media (max-width: 500px) {
          width: 1.7rem;
          height: 1.7rem;
          font-size: 0.9rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .disabled {
        opacity: 0.6 !important;
        cursor: unset;
        &:active {
          transform: unset;
        } 
      }

      .trash {
        width: 2rem;
        height: 2rem;
        background-color: rgb(196, 79, 68);
        border-radius: 0.5rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }
        @media (max-width: 500px) {
          width: 1.7rem;
          height: 1.7rem;
          font-size: 0.9rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }
    }
  }

  .record-bar {
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    border-top: 2px dashed rgb(116, 111, 111);
    display: flex;
    flex-direction: row;

    .record-box {
      width: 11.5rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .record {
        width: 1.9rem;
        height: 1.9rem;
        font-size: 1.1rem;
        border-radius: 50%;
        background-color: rgb(224, 224, 224);
        color: rgb(224, 116, 106);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: 0.3s;
        @media (max-width: 1000px) {
          width: 1.7rem;
          height: 1.7rem;
          font-size: 0.95rem;
        }
      }

      .recording {
        animation: flashing 2s infinite;
        background-color: rgb(224, 116, 106);
        color: rgb(224, 224, 224);
      }

      @keyframes flashing {
        20% {
          background-color: rgb(224, 116, 106);
        }
        50% {
          background-color: rgb(196, 33, 19);
        }
        80% {
          background-color: rgb(224, 116, 106);
        }
      }

      .timer {
        width: 7rem;
        height: 2.2rem;
        margin-left: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
      }
    }
  }

  .tts-bar {
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    border-top: 2px dashed rgb(116, 111, 111);
    display: flex;
    flex-direction: row;

    .label {
      margin-left: 1rem;
      font-size: 1rem;
      color: white;
    }

    select {
      margin-left: 1rem;
      width: 15rem;
      height: 1.8rem;
      border-radius: 0.3rem;
      outline: none;
    }
  }

  .feedback-bar {
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    border-top: 2px dashed rgb(116, 111, 111);
    display: flex;
    flex-direction: row;

    .feedback-status {
      flex: auto;
      max-width: 9rem;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;

      .info {
        width: 1.9rem;
        height: 1.9rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .info-active {
        color: white;
        background-color: #0080FF;
      }

      .success {
        width: 1.9rem;
        height: 1.9rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .success-active {
        color: white;
        background-color: #11b6a5;
      }

      .error {
        width: 1.9rem;
        height: 1.9rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .error-active {
        color: white;
        background-color: rgb(196, 79, 68);
      }

    }
    .feedback-message {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        width: 90%;
        height: 70%;
        border-radius: 0.3rem;
        outline: none;
        border: none;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        font-size: 0.9rem;
      }
    }
  }

}
</style>